













import { Component, Vue, Prop } from "vue-property-decorator";
import { Participant } from "@/types";

import * as twilio from "twilio-video";

@Component
export default class VideoBox extends Vue {
  @Prop({ required: true, default: false })
  isMe!: boolean;

  @Prop({ default: false })
  highlight!: boolean;

  @Prop({ required: true })
  participant!: twilio.Participant;

  @Prop({ required: false, default: false })
  muted!: boolean;

  novideo = false;

  mounted() {
    const video = this.$refs.video as HTMLMediaElement;
    const audio = this.$refs.audio as HTMLMediaElement;
    this.participant
      .on("trackPublished", this.addTrack)
      .on("trackSubscribed", this.addTrack)
      .on("trackEnabled", this.addTrack)
      .on("trackPublished", this.addTrack)
      .on("trackDisabled", this.removeTrack)
      .on("trackUnpublished", this.removeTrack)
      .on("trackUnsubscribed", this.removeTrack);

    this.videoTracks.forEach(publication => {
      if (publication.track && publication.isTrackEnabled) {
        publication.track.attach(video);
        video.load();
      }
    });
    this.participant.audioTracks.forEach(publication => {
      if (publication.track && publication.isTrackEnabled) {
        publication.track.attach(audio);
      }
    });
  }

  addTrack(
    publication: twilio.VideoTrackPublication | twilio.AudioTrackPublication | twilio.AudioTrack | twilio.VideoTrack,
  ) {
    const video = this.$refs.video as HTMLMediaElement;
    const audio = this.$refs.audio as HTMLMediaElement;
    if ("track" in publication) {
      if (publication.kind === "video" && publication.track !== null) {
        publication.track.attach(video);
        video.load();
        this.novideo = false;
      } else if (publication.kind === "audio" && publication.track !== null) {
        publication.track.attach(audio);
      }
    } else {
      if (publication.kind === "video") {
        publication.attach(video);
        video.load();
        this.novideo = false;
      } else if (publication.kind === "audio") {
        publication.attach(audio);
      }
    }
  }

  removeTrack(publication: twilio.VideoTrackPublication | twilio.AudioTrackPublication) {
    const video = this.$refs.video as HTMLMediaElement;
    const audio = this.$refs.audio as HTMLMediaElement;
    if (publication.kind === "video") {
      this.novideo = true;
      video.pause();
      video.removeAttribute("src");
      video.load();
      video.srcObject = null;
    } else if (publication.kind === "audio") {
      audio.pause();
      audio.removeAttribute("src");
      audio.load();
      audio.srcObject = null;
    }
  }

  get videoTracks() {
    return this.participant.videoTracks;
  }

  beforeDestroy() {
    this.participant
      .removeListener("trackPublished", this.addTrack)
      .removeListener("trackSubscribed", this.addTrack)
      .removeListener("trackEnabled", this.addTrack)
      .removeListener("trackPublished", this.addTrack)
      .removeListener("trackDisabled", this.removeTrack)
      .removeListener("trackUnpublished", this.removeTrack)
      .removeListener("trackUnsubscribed", this.removeTrack);
    this.participant.videoTracks.forEach(publication => {
      if (publication.track) {
        const attachedElements = publication.track.detach();
        attachedElements.forEach((element: HTMLMediaElement) => {
          element.pause();
          element.removeAttribute("src");
          element.remove();
          element.load();
        });
      }
    });
  }
}
